var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCrown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M27.9504 31.6337H12.0504C11.3504 31.6337 10.7171 31.1837 10.4837 30.5337L3.5504 11.1171C3.0004 9.56706 4.76707 8.25039 6.08373 9.20039L12.7504 13.9671C13.6337 14.6004 14.9004 14.2171 15.2837 13.2004L18.4337 4.80039C18.9671 3.35039 21.0171 3.35039 21.5504 4.80039L24.7004 13.2004C25.0837 14.2337 26.3337 14.6004 27.2337 13.9671L33.9004 9.20039C35.2337 8.25039 36.9837 9.58372 36.4337 11.1171L29.5004 30.5337C29.2837 31.1837 28.6504 31.6337 27.9504 31.6337Z",
    fill: "#4D4DFE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3337 36.666H11.667C10.9837 36.666 10.417 36.0993 10.417 35.416C10.417 34.7327 10.9837 34.166 11.667 34.166H28.3337C29.017 34.166 29.5837 34.7327 29.5837 35.416C29.5837 36.0993 29.017 36.666 28.3337 36.666Z",
    fill: "#4D4DFE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1663 24.584H15.833C15.1497 24.584 14.583 24.0173 14.583 23.334C14.583 22.6507 15.1497 22.084 15.833 22.084H24.1663C24.8497 22.084 25.4163 22.6507 25.4163 23.334C25.4163 24.0173 24.8497 24.584 24.1663 24.584Z",
    fill: "#4D4DFE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrown);
export default __webpack_public_path__ + "static/media/crown.e9a08ec8497e2f36a91ca17a3cde509f.svg";
export { ForwardRef as ReactComponent };